export const SERVER_HOST = 'https://dev.lfs.rest/api'
